// @flow

import React from 'react';
import styled from '@emotion/styled';

import Modal from 'app/components/commons/Modal';
import Button from 'app/components/commons/Button';

type Props = {
  onCancel: () => void,
  onConfirm: () => void,
  siteName: string
};

const StyledButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing.small
}));

const TermsModal = ({ onCancel, onConfirm, siteName }: Props) => (
  <Modal isOpen onCancel={onCancel} shouldCloseOnOverlayClick size="small">
    <p style={{ marginBottom: '1rem' }}>
      The cruncher tool is currently being beta tested. By using the cruncher you acknowledge and
      accept the functionality might not work as expected. {siteName} and Fantasy Insider will not
      be liable in the event of any errors. It is a user&apos;s responsibility to check lineups that
      have been generated on the cruncher before entering the contests.
    </p>
    <StyledButton block kind="success" onClick={onConfirm}>
      I accept these terms and want to use the cruncher
    </StyledButton>
    <Button block kind="danger" onClick={onCancel}>
      I do not accept these terms
    </Button>
  </Modal>
);

export default TermsModal;
